<template>
<div class="post-comment-wrap">

<!-- COMMENT FORM -->
    
        <form 
        class="post-comment-form" 
        @submit="postComment">

            <div class="d-f">
                <textarea 
                    ref="focusOn"
                    class="comment-input" 
                    type="text"
                    placeholder="Comment..."
                    v-model="commentInput"
                />

                <div class="close" @click="emitDisplayPostComment()">
                    <IconCancel class="icon-cancel" />
                </div>
            </div>

            <div class="f-d-headlines">
                <small>Mark Fallacy:</small>
                <small>Mark Debater:</small>
            </div>
            <div class="fallacies-debaters-wrap">
                <div class="fallacies" action="submit">

                    <div class="fallacy" :class="{ checked : radioFchecked('Ad Hominem') }" @click="radioFchange('Ad Hominem')">
                        <div class="radio"></div><div class="name">Ad Hominem</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Appeal to Authority') }" @click="radioFchange('Appeal to Authority')">
                        <div class="radio"></div><div class="name">Appeal to Authority</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Appeal to Ignorance') }" @click="radioFchange('Appeal to Ignorance')">
                        <div class="radio"></div><div class="name">Appeal to Ignorance</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Alphabet Soup') }" @click="radioFchange('Alphabet Soup')">
                        <div class="radio"></div><div class="name">Alphabet Soup</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Bandwagon') }" @click="radioFchange('Bandwagon')">
                        <div class="radio"></div><div class="name">Bandwagon</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Circular Argument') }" @click="radioFchange('Circular Argument')">
                        <div class="radio"></div><div class="name">Circular Argument</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('False Dilemma') }" @click="radioFchange('False Dilemma')">
                        <div class="radio"></div><div class="name">False Dilemma</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Red Herring') }" @click="radioFchange('Red Herring')">
                        <div class="radio"></div><div class="name">Red Herring</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Slippery Slope') }" @click="radioFchange('Slippery Slope')">
                        <div class="radio"></div><div class="name">Slippery Slope</div>
                    </div>
                    <div class="fallacy" :class="{ checked : radioFchecked('Straw Man') }" @click="radioFchange('Straw Man')">
                        <div class="radio"></div><div class="name">Straw Man</div>
                    </div>
                </div>
                <div class="debaters">
                    <div v-for="debater in post.debaters" :key="debater.id">
                        <div class="debater" :class="{ checked : radioDchecked(debater.name) }" @click="radioDchange(debater.name)">
                            <div class="name">{{ debater.name }}</div><div class="radio"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="slidecontainer">
                <input type="range" min="1" max="100" value="50" class="slider" id="myRange">
            </div> -->

            <!-- <div class="time-picker d-f">
            <input type="number" min="0" max="60" placeholder="0">
            s
            <input type="number" min="0" max="60" placeholder="0">
            m
            <input type="number" min="0" max="60"placeholder="0">
            h
            </div> -->

            <p class="errors" v-if="errors.length">
                <b>Please correct the following error(s):</b>
                <ul>
                <li v-for="error in errors" :key="error.id">{{ error }}</li>
                </ul>
            </p>

            <div class="post-button">
                <button 
                    v-if="userinfo"
                    class="active"
                    type="submit"
                    value="Submit">
                    <h1>Post →</h1>
                </button>
                <div
                    v-else 
                    class="inactive">
                    <h1>
                        <span class="active-color">You have to</span>
                        <span class="button-text" @click="toggleLogin(); showSignUp('login');">&nbsp;Login&nbsp;</span> 
                        <span>/</span>
                        <span class="button-text" @click="toggleLogin(); showSignUp('join');">&nbsp;Join&nbsp;</span>
                        <span class="active-color">to post</span>
                    </h1>
                </div>
            </div>

        </form>

<!-- POSTED COMMENTS -->
    
</div>
</template>

<script>
import { db, auth, time } from '../db'
import * as firebase from 'firebase'
import IconCancel from '../assets/icons/IconCancel.vue'

export default {
    name: 'CommentPost',
    props: [
        'post',
        'userinfo',
    ],
    components: {
        IconCancel
    },
    data() {
        return {
            errors: [],
            commentInput: '',
            truncateComment: true,
            showPostComment: false,
            radioFvalue: false,
            radioDvalue: false
        }
    },
    mounted() {
        // this.$refs.focusOn.focus();
        this.focusInputDesktopOnly()
    },
    methods: {
        focusInputDesktopOnly() {
            if (window.screen.width >= 1024) {
                this.$refs.focusOn.focus();
            } else {
                return
            }
        },
        radioFchecked(x) {
            return this.radioFvalue === x ? true : false;
        },
        radioFchange(x) {
            return this.radioFvalue === x ? this.radioFvalue = false : this.radioFvalue = x;
        },
        radioDchecked(x) {
            return this.radioDvalue === x ? true : false;
        },
        radioDchange(x) {
            return this.radioDvalue === x ? this.radioDvalue = false : this.radioDvalue = x;
        },
        emitDisplayPostComment() {
            this.$emit('emitDisplayPostComment')
        },
        togglePopMess(payload) {
            this.$store.commit('togglePopMess', payload)
        },
        toggleLogin(payload) {
        this.$store.commit('toggleLogin', payload)
        },
        showSignUp(payload) {
        this.$store.commit('showSignUp', payload)
        },
        postComment(e) {
            if (!this.userinfo) {
                this.$store.commit('toggleLogin')
                this.$store.commit('togglePopMess', 'Login to post')
            } else {
                if ((this.commentInput === '') && (!this.radioFvalue) && (!this.radioDvalue)) {
                    this.errors.push('All fields empty');
                }
                else if (this.radioFvalue && !this.radioDvalue) {
                    this.errors.push('You have to mark debater to marked fallacy');
                }
                else if (!this.radioFvalue && this.radioDvalue) {
                    this.errors.push('You have to mark fallacy to marked debater');
                } else {                
                    const postRef = db.collection('posts').doc(this.post.id)

                    // Data från ny kommentar
                    const data = { 
                        uid: this.userinfo.uid,
                        firstname: this.userinfo.firstname,
                        lastname: this.userinfo.lastname,
                        comment: this.commentInput,
                        when: new Date(),
                        fallacyMark: this.radioFvalue,
                        debaterMark: this.radioDvalue
                    };
                    // Hämtar kommentarerna
                    const foo = { 
                        'comments': this.post.comments || []
                    };
                    foo['comments'].push(data);
                    // Pushar in nya kommentareren med dom gamla och sen skriver över comments arrayen i db'n
                    postRef.update(foo).then(()=> {
                        console.log('Post comments updated')
                        // Addera kommentaren också till en subcollection för framtida funktioner så som filtrera fram kommentarer eller replies/likes etc
                        postRef.collection('allComments').add(data).then(() => { 
                            console.log('allComments subcoll updated')
                        }).catch(err => { console.error(err) })
                    }).catch(err => { console.error(err) })
                }
                this.commentInput = ''
                e.preventDefault()
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.post-comment-wrap {
    //This is for the bottom positioning on mobile to work 
    position: absolute;
    .post-comment-form {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        background-color: $grey;
        display: flex;
        flex-direction: column;
        .comment-input {
            resize: none;    
            font-size: $h1;
            margin: $main-margin $grid-padding 0 $grid-padding;
            width: 100%;
            line-height: 1.2;
            border-bottom: none;
            &::placeholder {
                color: $p-color;
            }
        }
        .close {
            margin: $main-margin $grid-padding 0 $grid-padding;
            display: flex;
            justify-content: flex-end;
            height: 24px;
            .icon-cancel {
                padding: 0;
            }
        }

        .f-d-headlines {
            margin: 0 $grid-padding;
            display: flex;
            justify-content: space-between;
        }
        .fallacies-debaters-wrap {
            position: relative;
            margin: $main-margin $grid-padding;
            width: auto;
            box-sizing: border-box;
            display: flex;
            .fallacies {
                display: flex;
                flex-wrap: wrap;
                .fallacy {
                    display: flex;
                    flex-shrink: 0;
                    align-items: center;
                    margin-right: 10px;
                    flex-basis: $col2;
                    min-width: 200px;
                    flex-shrink: 0;
                    white-space: pre;
                }
            }
            .debaters {
                display: flex;
                flex-direction: column;
                .debater {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    white-space: pre;
                    flex-shrink: 0;
                    width: $col2;
                }
            }

            .radio {
                position: relative;
                width: 10px;
                height: 10px;
                border: $line-bold solid $black;
                border-radius: 50%;
                flex-shrink: 0;
            }
            .name {
                margin: 0 10px;
            }
            .checked {
                .radio {
                    background-color: $icon-hover-color;
                }
                .name {
                    color: $icon-hover-color;
                }
            }
            .fallacy, .debater {
                @media #{$no-mob-hover} {
                    &:hover {
                        cursor: pointer;
                        .radio {
                            background-color: $black;
                        }
                        .name {
                            color: $icon-hover-color;
                        }
                    }
                }
            }

        }
        .errors {
            margin: 0 $grid-padding;
            padding-bottom: $main-margin;
            color: red;
            ul {
                margin: 0;
            }
        }

.slidecontainer {
  width: 100%;
  padding: $grid-padding;
  box-sizing: border-box;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 0;
  background: transparent;
  border: 1px solid $black;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;
  cursor: pointer;
}

.slider:hover {
  &::-webkit-slider-thumb {
      background: $icon-hover-color;
  }
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  background: $grey;
  cursor: pointer;
  border: 2px solid $black;
  border-radius: 50%;
}

.slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: $black;
  cursor: pointer;
}
        .post-button {
            position: relative;
            button {
                border: none;
            }
            .active, .inactive {
                width: 100%;
            }
            .active {
                background-color: $black;
                h1 {
                    color: $white;
                    text-align: right;
                    padding: 0 $grid-padding;
                }
                @media #{$no-mob-hover} {
                    &:hover {
                        cursor: pointer;
                        background-color: $icon-hover-color;
                        h1 {
                            color: $black;
                        }
                    } 
                }
            }
            .inactive {
                background-color: $grey;
                h1 {
                    padding: 0 $grid-padding;
                }
            }
        }
    }

}
// MOBILE
@media #{$mobile} {    
.post-comment-wrap {
    .post-comment-form {
        padding-top: $main-margin-mobile;
        height: auto;
        .fallacies-debaters-wrap { 
            margin: $main-margin-mobile;
            font-size: $p2;
            .radio {
                width: 8px;
                height: 8px;
                border: $line-thin solid $black;
            }
        }
        .f-d-headlines { 
            margin: 0 $main-margin-mobile;
        }
        .comment-input {
            margin: $main-margin-mobile;
            font-size: $p1;
        }
        textarea {
            resize: none;
            font-size: $p1;
        }
        .close {
            margin: $main-margin-mobile;
        }
        .post-button {
            // position: absolute;
            bottom: 0;
            width: 100%;
            .active, .inactive {
                h1 {
                    padding: 0 $main-margin-mobile $main-margin $main-margin-mobile;
                    font-size: $p1;
                }
            }
        }
    }

}
}

</style>
